<script setup>
import { computed } from "vue";
import { Link } from "@inertiajs/inertia-vue3";

const props = defineProps(["active", "href"]);

const classes = computed(() =>
  props.active
    ? "inline-flex items-center px-4 font-medium leading-5 text-white bg-oteo-300 transition  duration-150 ease-in-out"
    : "inline-flex items-center px-4 font-medium leading-5 text-white h-full hover:bg-oteo-300 transition duration-150 ease-in-out"
);
</script>
<template>
  <a :href="props.href" :class="classes">
    <slot />
  </a>
</template>
